import React from "react";
import useNotifications from "../../../core/Notifications";

export const withRuleEditor = (Component) => (props) => {
    const notifications = useNotifications();

    return <Component {...props} notifications={notifications} />
}